module.exports = __webpack_public_path__ + "img/footer-bg.eb2ee6a1.png";